import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Advance from './Advance'
import Public from './Public'

export default class AdvancedSettings extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    organization: PropTypes.object
  }

  static fragment = gql`
    fragment documentAdvancedSettings on Document {
      isPublic
      requireTwoFactor
    }
  `
  state = {}

  render() {
    //console.log("Advanced Settings");
    if (!this.props.document.signatureRequested) {
      return <Advance document={this.props.document} organization={this.props.organization} />
    } else {
      return <Public document={this.props.document} organization={this.props.organization} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/AdvancedSettings/index.js